const PATH_BASE = process.env.REACT_APP_BACKEND_API_URL + '/api/v1/files';

export const getFilesURL = (fileId: string) => {
    return PATH_BASE + '/' + fileId;
}

const FileAPI = {
    getFilesURL
}

export default FileAPI